<script>
    import { fade } from 'svelte/transition';
    import {link , push } from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { validateFields }  from '../base/validation.js';
	import { silentPrint }  from '../base/printer.js';
    import { send_iframe_data }  from '../base/shipments.js';
    import { systemUrl } from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy , tick } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import Popup from '../components/Popup.svelte'; 
    //import App from '../App.svelte';

    let isLoading = true; 
    let print_url = '';
    let create_new = false;
    let popupMsg = "";
    let popupShow = false;
    
    

    export let params;   

    let order_id = params?.shipment_id ?? ''
    
    let tracking_number = false;

    $: {
        
        if (shipment.destination.shipment_type==2) {          
            getStores(postData)            
        }
    }

    $: location_id = shipment.destination.datalogics_location;


    const getStores = async () => {

        let postData = {};
        postData.platform_id = shipment.destination.datalogics_platform_id;
        postData.action = 'crm_stores_by_platform';
        postData.token = $UserStore.data

        let response = await fetchData(postData);

        //console.log('response',response);

        if (response.data) {

            //stores = response.data; 

            const keyValueArray = Object.entries(response.data);

            // Sort the array by keys
            keyValueArray.sort((a, b) => a[0].localeCompare(b[0]));

            // Convert the sorted array back to an object
            stores = Object.fromEntries(keyValueArray);

            console.log(shipment.destination.datalogics_n_code);

            if (shipment.destination.datalogics_n_code!='') {
                for(let key in stores) {
                    stores[key].filter((store)=> {
                        
                        if (store.n_code == shipment.destination.datalogics_n_code) {
                            
                            shipment.destination.datalogics_n_code_city = store.city

                            console.log(stores[shipment.destination.datalogics_n_code_city]);
                        }
                    })
                }
            }

        }
    }    

    let stores = [];
    let settings = {};
    let general_settings = {};
    let shipping_methods = [];
    let locations = [];
    let selected_shipping_method = {}
    


    let shipment = {
        status_code : 0,
        external_id : '',
        shipping_method : '',
        order_status : '',
        status : [],
        items : [],
        shipment_id : '',
        order_name : '',
        platform_id : '',
        order_id : order_id,
        general_comments : '',
        reference : '',
        origin : {
            // fullname : '',
            // phone : '',
            // email : '',
            // city : '',
            // address : '',
            // house : '',
            // entrance : '',
            // apartment : '',
            // floor : '',
            // door : '',
            comments : ''
        },
        destination : {
            datalogics_fullname : '',
            datalogics_phone : '',
            datalogics_email : '',
            datalogics_city : '',
            datalogics_address : '',
            datalogics_house : '',
            datalogics_entrance : '',
            datalogics_apartment : '',
            datalogics_floor : '',
            datalogics_door : '',
            datalogics_shipment_type : "1",
            datalogics_shipment_select : "1",
            datalogics_package_type : "1",
            datalogics_govina_sum : '',
            datalogics_comments : '',
            datalogics_n_code : '',
            datalogics_n_code_city : '',
            datalogics_n_code_auto : false,
            datalogics_platform_id : '',
            datalogics_reference : '',
            datalogics_location : 0,
            datalogics_packs : 1,
            datalogics_weight : ''
            
        }
    }

    // if ($meta->key=='datalogics_carrier_type') { $datalogics_carrier_type = $meta->value; }
    // if ($meta->key=='datalogics_shipment_type') { $datalogics_shipment_type = $meta->value; }
    // if ($meta->key=='datalogics_packs') { $packages = $meta->value; }
    // if ($meta->key=='datalogics_comment') { $products_shipping_comments .= ' '.$meta->value; }
    // if ($meta->key=='datalogics_location') { $location = $meta->value; }
    // if ($meta->key=='datalogics_platform_id') { $datalogics_platform_id = $meta->value; }     

    $: if (params.shipment_id !== order_id) {
        order_id = params.shipment_id;        
        fetchOrder();

    }

    onMount(async() => {
        fetchOrder()        
    })


    const fetchOrder = async() => {


        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        locations = $UserStore.settings?.shipping_settings?.datalogics_update_inventory_locations ?? []

        print_url = systemUrl + '/label?token=' + $UserStore.data + "&order_id=";


        settings = $UserStore.settings.shipping_settings;
        general_settings = settings;


        console.log('general_settings',general_settings)
        let type = typeof settings.shipping_method ;
        if (settings.shipping_method && settings.shipping_method.length) {
            shipping_methods = settings.shipping_method;
            selected_shipping_method = shipping_methods[0]
        } else {
            shipping_methods = [];
        }   


        if (shipping_methods.length==0) {
            push('/companies');
            return;
        }      

        shipment.destination.datalogics_platform_id = selected_shipping_method.shipping_push_supplier; 

        // shipment.origin = {
        //     fullname : settings.shipping_push_supplier_name,
        //     phone : settings.shipping_push_supplier_phone,
        //     email : settings.shipping_push_supplier_email,
        //     city : settings.shipping_push_supplier_city,
        //     address : settings.shipping_push_supplier_street,
        //     house : settings.shipping_push_supplier_house,
        //     entrance : settings.shipping_push_supplier_entrace,
        //     apartment : settings.shipping_push_supplier_apartment,
        //     floor : settings.shipping_push_supplier_floor,
        //     door : settings.shipping_push_supplier_door,
        //     comments : '',
        // };    
        
        // if (!settings.shipping_push_supplier_name) {
        //     shipment.origin.fullname = $UserStore.settings.shipping_settings.shipping_push_supplier_name;
        // }
        // if (!settings.shipping_push_supplier_house) {
        //     shipment.origin.house = $UserStore.settings.shipping_settings.shipping_push_supplier_house;
        // }
        // if (!settings.shipping_push_supplier_city) {
        //     shipment.origin.city = $UserStore.settings.shipping_settings.shipping_push_supplier_city;
        // }
        
        // if (!settings.shipping_push_supplier_street) {
        //     shipment.origin.address = $UserStore.settings.shipping_settings.shipping_push_supplier_street;
        // }
        
        
        if (params && params.shipment_id && params.shipment_id!="-1") {

            let postData = {};       

            postData.action = 'crm_get_shipment';
            postData.token = $UserStore.data
            postData.details = 1;
            
            postData.shipment_id = params.shipment_id
            let response = await fetchData(postData);

            if (response.data) {

                let shipping_data = response.data[0];

                let iFrameObject = {
                    area : shipping_data.area,
                    line_number : shipping_data.line_number,
                    tracking_number : shipping_data.shipment_id,
                    label_url : shipping_data.label,
                    platform_id : shipping_data.platform_id,
                    date : shipping_data.date,
                    platform_name : shipping_data.platform_name,
                    success : 1,
                    order_id : shipping_data.order_id,
                    ncode_details : shipping_data.ncode_details,
                    ncode : shipping_data.ncode,
                    msg : ''                    
                }   

                send_iframe_data(iFrameObject)

                if (shipping_data.platform_id) {
                    shipment.destination.datalogics_platform_id = shipping_data.platform_id;
                }

                shipment.external_id = shipping_data.external_id
                shipment.shipping_method = shipping_data.shipping_method
                shipment.status = shipping_data.status
                shipment.items = shipping_data.items
                for(var key in shipment.items) {
                    //console.log(shipment.items[key])
                    shipment.items[key].quantity_scanned = 0;
                    shipment.items[key].scanned_status = 0;
                }

                tracking_number = shipping_data.shipment_id;
                shipment.shipment_id = shipping_data.shipment_id;
                shipment.order_name = shipping_data.order_name;
                shipment.order_id = shipping_data.order_id;
                shipment.order_status = shipping_data.order_status;
                //shipment.platform_id = shipping_data.platform_id

                shipment.destination.datalogics_packs = shipping_data.packages;
                shipment.destination.datalogics_weight = shipping_data.weight;
                shipment.destination.datalogics_fullname = shipping_data.client_name;
                shipment.destination.datalogics_phone = shipping_data.client_phone;
                shipment.destination.datalogics_email = shipping_data.client_email;
                shipment.destination.datalogics_city = shipping_data.client_city;
                shipment.destination.datalogics_address = shipping_data.client_street;
                shipment.destination.datalogics_house = shipping_data.client_house;
                shipment.destination.datalogics_entrance = shipping_data.shipping_entrance;
                shipment.destination.datalogics_apartment = shipping_data.client_apartment;
                shipment.destination.datalogics_floor = shipping_data.client_floor;
                shipment.destination.datalogics_door = shipping_data.shipping_door;
                shipment.destination.datalogics_package_type = (shipping_data.package_type) ? shipping_data.package_type : "1";
                shipment.destination.datalogics_shipment_type = shipping_data.shipment_type;
                shipment.destination.datalogics_shipment_select = "1";
                shipment.destination.datalogics_govina_sum = '';
                shipment.destination.datalogics_comments = shipping_data.comments;
                shipment.destination.datalogics_n_code = (shipping_data.ncode!='') ?  (shipping_data.ncode) : '';
                shipment.destination.datalogics_n_code_auto =  (shipping_data.ncode=='auto') ?  true : false;
                shipment.destination.datalogics_n_code_city = '';
                shipment.destination.datalogics_location = 0;
                shipment.destination.datalogics_reference = shipping_data.order_name;

                if (shipment.destination.datalogics_n_code!='' && shipment.destination.datalogics_n_code!=null) {
                    shipment.destination.datalogics_shipment_select = "2";
                }
            
                


                // postData.action = 'crm_get_shipments';
                // postData.token = $UserStore.data
                // let data = await fetchData(postData);
                // orders = data.data.filter((item) => {
                //     const dateTimeParts = item.date.split(" ");
                //     item.current_date = dateTimeParts[0];
                //     item.current_time = dateTimeParts[1];
                //     if (item.shipment_id.startsWith("RG")) {
                //         item.type = 2; 
                //         pickup_count++;
                //     } else {
                //         item.type = 1; 
                //         door_count++;
                        
                //     }
                //     return true; 
                // });  



                
                
                

            }

        }

        getStores()

        isLoading = false; 

        await tick();
        let barcodeId = '';
        console.log(shipment.items)
        for(var key in shipment.items) {
            
            if (shipment.items[key]?.sku!='' || shipment.items[key]?.sku!=null) {
                // console.error(shipment.items[key].sku)
                barcodeId = "#barcode" + key;
                if (document.querySelector(barcodeId)) {
                    JsBarcode(barcodeId, shipment.items[key].sku, {
                        width: 2, 
                        height: 20, 
                    });
                }
            }
        }


        document.addEventListener('keydown', handleKeyDown);


        
        
        
    }


    onDestroy(() => {
        document.removeEventListener('keydown', handleKeyDown);
    });

    const CancelShipment = async() => {


        let postData = {}; 
        postData.action = 'crm_cancel_shipment';   
        postData.token = $UserStore.data;    
        postData.order_id = shipment.order_id;
        let response = await fetchData(postData);
        console.log('CancelShipment',response);
        if (response.data) {
            tracking_number = '';
            shipment.shipment_id = '';
        }

    }

    const handleSubmit = async() => {


        //if ([91, 1294, 972].includes($UserStore.id)) {
        if ($UserStore.id==91 || $UserStore.id==972 || $UserStore.id==1294) {
            const allItemsHaveStatus2 = Object.keys(shipment.items).every(function(key) {
                return shipment.items[key].scanned_status === 2;
            });
            if (!allItemsHaveStatus2) {
                if(!confirm('ישנם פריטים שלא נסרקו, האם ברצונך להמשיך?')) {
                    return;
                }
            }
        }
        
        if (create_new) {
            
            if(!confirm('להזמנה זו כבר נוצר שטר מטען, במידה ותאשרו יווצר להזמנה זו שטר מטען נוסף')) {
                return;
            }
        }

        if (!validateFields(shipment.destination)) {
            alert('יש מלא את כל השדות חובה')
            return;
        }


        isLoading = true;

        if (shipment.destination.datalogics_n_code_auto==true) {
            shipment.destination.datalogics_n_code = 'auto';
        }
        

        let postData = {}; 
        postData.action = 'crm_create_shipment';   
        postData.token = $UserStore.data;    
        postData.order_id = shipment.order_id;
        //postData.platform_id = shipment.platform_id;
        postData.data = shipment.destination;

        

        if (create_new) {
            postData.create_new = true;
        }
        let response = await fetchData(postData);
        console.log('handleSubmit',response);
        if (response.data) {

            let iFrameObject = response.data
            send_iframe_data(iFrameObject)

            tracking_number = response.data.shipment_id;
            shipment.shipment_id = response.data.shipment_id;
            if (response.data.order_id!=order_id) {
                order_id = response.data.order_id;
                shipment.order_id = order_id;
                shipment.order_name = response.data.order_name;
                push('/shipment/'+shipment.order_id)
            }

            if (shipment.shipment_id===null && response.data.shipping_error !==null) {

                if (response.data.shipping_error == "") {

                    response.data.shipping_error = 'שגיאה 911 יש לפנות לשירות לקוחות';

                }

                popupMsg = response.data.shipping_error;
                popupShow = true;

            }

            // BulkPrint();
        }

        isLoading = false;
    }


    let scannedBarcode = '';

    function handleKeyDown(event) {

        // if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable) {
        //     return;
        // }

        // Check if the key pressed is a number or Enter
        if (/^[a-zA-Z0-9]$/.test(event.key)) {

            scannedBarcode += event.key;

        } else if (event.key === 'Enter') {

            console.log('scannedBarcode',scannedBarcode)

            if (scannedBarcode.startsWith('E')) {
                scannedBarcode = scannedBarcode.substring(1);
            }

            //alert(scannedBarcode);

            let barcodePassed = false;
            let barcodeKey = '';

            for(var key in shipment.items) {
                if (shipment.items[key].barcode==scannedBarcode || shipment.items[key].sku==scannedBarcode) {
                    barcodePassed = true;
                    barcodeKey = key
                }
            }

            if (!barcodePassed) {
                // Handle the case when the note does not exist
                alert('ברקוד אינו קיים ברשימה');
                scannedBarcode = '';
                return;
            }

            scannedBarcode = '';

            handleItemsScannCount(barcodeKey)
            
        }
    }

    function handleItemsScannCount(barcodeKey) {


        shipment.items[barcodeKey].quantity_scanned++;
        if (shipment.items[barcodeKey].quantity_scanned>=shipment.items[barcodeKey].quantity) {
            shipment.items[barcodeKey].scanned_status = 2;
            shipment.items[barcodeKey].quantity_scanned = shipment.items[barcodeKey].quantity;
        } else {
            shipment.items[barcodeKey].scanned_status = 1;
        }

        shipment.items = [...shipment.items]


        const allItemsHaveStatus2 = Object.keys(shipment.items).every(function(key) {
            return shipment.items[key].scanned_status === 2;
        });


        if (typeof settings.create_shipment_after_scan!== undefined && settings.create_shipment_after_scan=="1") {

            if (allItemsHaveStatus2) {

                create_new = false; 
                handleSubmit();
                setTimeout(function(){
                    //sendPrintJob(order_id,$UserStore);
                },7000)

                window.history.back();
                    
            }

        }

    }


    const BulkPrint = () => {

        console.log($UserStore.id)

        if ($UserStore.id==2353 || $UserStore.id==91) {

            console.log('inside'+$UserStore.id,$UserStore.settings.shipping_settings.printer)

            silentPrint(print_url + order_id,$UserStore.settings.shipping_settings.printer);

        } else {
        
            const printWindow = window.open(print_url + order_id, '_blank');

            if (typeof settings.automatic_print_after_creation_of_tracking!== undefined && settings.automatic_print_after_creation_of_tracking=="1") {

                printWindow.onload = function () {
                    printWindow.print();
                };

            }

        }

    }


    const closePopup = async(event) => {
        popupShow = !popupShow;
    }

    function printSlip() {

        const slip_url = systemUrl + '/print_packingslip?token=' + $UserStore.data + "&order_id=";
        const printWindow = window.open(slip_url + order_id, '_blank');

    }

    async function changeStatus() {


        if(!confirm('פעולה זו תשנה את סטטוס ההזמנה באתר. האם הינך בטוח?')) {
            return;
        }

        isLoading = true;

        let postData = {}; 
        postData.action = 'crm_close_order_source';   
        postData.token = $UserStore.data;  
        postData.settings = {}; 
        
        postData.order_id = shipment.order_id

        let response = await fetchData(postData);
        if (response.msg) {         
            
            if (response.msg !="") {

                popupMsg = response.msg;
                popupShow = true;

            } 
        }

        if (response.success) {
            shipment.status_code = 3;
        }

        isLoading = false;
        
    }

    async function createOrder() {        

        isLoading = true;

        console.log('shipmentshipmentshipmentshipment',shipment)

        let postData = {}; 
        postData.action = 'w_erp_order_create';   
        postData.token = $UserStore.data;  
        postData.settings = {}; 
        
        postData.order = {
            id : shipment.order_id
        }
        postData.get_original_order_data = 1;


        let response = await fetchData(postData);
        if (response.msg) {         
            
            if (typeof response.external_id!=="undefined") {
                shipment.external_id = response.external_id;
            }

            if (response.msg !="") {

                popupMsg = response.msg;
                popupShow = true;

            }

        }

        isLoading = false;

    }


    function shouldHighlight(inventory) {

        if (!Array.isArray(inventory)) {
            return false;
        }

        if (typeof $UserStore.erp !== 'undefined' && $UserStore.erp==1) {

            const checkStoreIds = ["1", "69", "70", "79", "791"];

            return inventory
                .filter(item => checkStoreIds.includes(item.store_id)) // Get only relevant stores
                .every(item => Number(item.quantity) <= 0); // Check if all are 0 or less

        }
    }

    function handlePlatformChange(event) {
        shipment.destination.datalogics_platform_id = event.target.value;
        getStores();
        console.log(event.target.value)
    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">  
        <Popup {popupMsg} {popupShow} on:closePopup={closePopup} />  
        <TopInfo/>
        <div class="shipment">

            <!-- <a href="{print_url}{shipment.order_id}&details=1" target="_blank">
                <i class="fa-solid fa-print red-color"></i>
                {$_('shipment.full_details')} 
            </a> -->

            {#if shipment.shipment_id}
            <div class="shipment_notification">
                {$_('shipment.your_tracking_number_created')} 
                <a href="{print_url}{shipment.order_id}" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <strong>{shipment.shipment_id}</strong>
                    {$_('shipment.print_click_here')} 
                </a>

                <!-- <a href="{print_url}{shipment.order_id}&details=1" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <strong>{shipment.shipment_id}</strong>
                    {$_('shipment.full_details')} 
                </a> -->
            </div>            
            {/if}
            <div class="flex justify-between">
                <h1 class="text-[20px] font-bold">
                    <div class="flex gap-2 items-center">
                        <div>
                        {#if shipment.order_id}
                            {$_('shipment.order_name')}: {shipment.order_name} {#if shipment.order_name!=shipment.order_id && shipment.order_id>0}({shipment.order_id}){/if}
                        {:else}
                            {$_('shipment.shipment_name')}
                        {/if}
                        </div>
                        {#if shipment?.order_status}
                        <div 
                            class="text-[12px] text-center rounded-[2px] px-2"
                            class:bg-green-100={shipment?.order_status === 'completed' || shipment?.order_status === 'processing' || shipment?.order_status === 'done' || shipment?.order_status === 'paid'}
                            class:bg-red-100={shipment?.order_status !== 'completed' && shipment?.order_status !== 'processing' || shipment?.order_status !== 'done' || shipment?.order_status !== 'paid'}
                        >
                                {$_('shipment.order_status')}: {shipment?.order_status}
                            </div>
                        {/if}
                        {#if shipment?.shipping_method }
                        <div class="text-[12px] text-center rounded-[2px] px-2 bg-amber-100">
                                {$_('shipment.shipping_method')}: {shipment?.shipping_method}
                        </div>   
                        {/if}
                        {#if shipment?.external_id }
                        <div class="text-[12px] text-center rounded-[2px] px-2 bg-emerald-100">
                                {$_('shipment.invoice_name')}: {shipment?.external_id}
                        </div>   
                        {/if}
                    </div>
                    <!-- {#if shipment?.external_id!=null}
                        <div class="text-[12px]">{$_('shipment.invoice_name')}: {shipment?.external_id}</div>               
                    {/if}                     -->
                </h1>  
                {#if order_id < 0}
                <div class="flex justify-end">
                    <span on:click={()=> { push('/shipment/-1' ); window.location.href = '/#/shipment/-1'; window.location.reload() }} class="create_button m-0"><span>{$_('orders.new')}</span></span>
                </div>
                {/if}
            </div>

            {#if !locations[location_id]}
                <div>
                    {$_('shipment.locations_msg')}
                    <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a>
                </div>
            {:else}
                {#if shipment.shipment_id && shipment.shipment_id!=''}
                <div class="shipment-status">
                    <div class="shipment_header">
                        <i class="fa-solid fa-street-view"></i> {$_('shipment.statuses')}
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head shipment-status-line">
                            <div>{$_('shipment.date')}</div>
                            <div>{$_('shipment.status')}</div>
                        </div>
                        {#each shipment.status as item}
                        <div class="shipment-items-line shipment-status-line">                            
                            <div>{item.date}</div>
                            <div>{item.status}</div>
                        </div>
                        {/each}
                    </div>
                </div>
                {/if}
                {#if shipping_methods.length>1}
                <div class="shipping_companies mt-5">
                    <label>{$_('companies.shipping_company')}</label>
                    <select bind:value={shipment.destination.datalogics_platform_id} on:change={handlePlatformChange}>
                    {#each shipping_methods as method}
                        {#if platforms && platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.name!=''}
                            <option value="{method.shipping_push_supplier}">{platforms[+method.shipping_push_supplier].name}</option>
                        {/if}
                    {/each}
                    </select>
                </div>      
                {/if}
                {#if ((settings.enable_scanning_products && settings.enable_scanning_products=="1") || (general_settings.enable_scanning_products && general_settings.enable_scanning_products=="1")) && shipment.items && shipment.items.length}
                <div class="shipment-items">
                    <div class="shipment_header">
                        <i class="fa-solid fa-barcode"></i> {$_('items.items')}
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head">
                            {#if shipment.items.some(item => item.datalogics_location)}
                                <div>{$_('items.location')}</div>
                            {/if}
                            <div>{$_('items.sku')}</div>
                            <div>{$_('items.barcode')}</div>
                            <div>{$_('items.name')}</div>
                            <div>{$_('items.qty')}</div>
                            <div>{$_('items.qty_scanned')}</div>
                            <div>{$_('items.scanned_status')}</div>                            
                        </div>
                        {#each shipment.items as item,key}
                        <div class="shipment-items-line {shouldHighlight(item.inventory) ? 'bg-red-200' : ''}">
                            {#if item.datalogics_location}
                                <div>{item.datalogics_location}</div>
                            {:else}
                                {#if shipment.items.some(item => item.datalogics_location)}
                                    <div></div>
                                {/if}
                            {/if}                            
                            <div>
                                {item.sku}
                                <!-- {#if item.sku}
                                <svg id="barcode{key}"></svg>
                                {/if} -->
                            </div>
                            <div>
                                {#if item.barcode==undefined}
                                    -
                                {:else}
                                    {item.barcode}
                                {/if}
                            </div>
                            <div>{item.name}</div>
                            <div><div class="qty">{item.quantity}</div></div>
                            <div><div class="qty qty-scanned">{item.quantity_scanned}</div></div>
                            <div>
                                <div class="badge badge{item.scanned_status}" on:click={()=> { handleItemsScannCount(key) } }>
                                {#if item.scanned_status==0}
                                    {$_('items.not_scanned')}
                                {:else if item.scanned_status==1}
                                    {$_('items.partial_scanned')}
                                {:else}
                                    {$_('items.scanned')}
                                {/if}
                                </div>
                            </div>
                        </div>
                        {/each}
                    </div>
                    <!-- <div class="items-buttons">
                        <div class="shipment-flex-button">
                            <div class="create_button">{$_('items.create_invoice')}</div>
                        </div> 
                    </div> -->
                </div>
                {/if}
                <div class="shipment-flex">
                    <div class="shipment_origin">
                        <div class="shipment_header">
                            <i class="fa-regular fa-map"></i> {$_('shipment.origin')}
                        </div>   
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.location_name')} <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a></label>      
                                <select bind:value={shipment.destination.datalogics_location}>
                                {#each locations as location,index}
                                    {#if location.enabled}
                                    <option value="{index}">{location.name} - {location.street} {location.house} , {location.city} </option>
                                    {/if}
                                {/each}
                                </select>
                            </div>
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={locations[location_id].name} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={locations[location_id].phone} disabled>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={locations[location_id].email} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={locations[location_id].city} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={locations[location_id].street} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.house')}</label>
                                <input type="text" bind:value={locations[location_id].house} disabled>
                            </div>
                        </div>
                        <!-- 
                        <div class="input_box">
                            
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.origin.entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.origin.floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.origin.apartment}>
                            </div>
                        </div>
                         -->
                        <!-- <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.origin_comments')}</label>
                                <input type="text" bind:value={shipment.origin.comments}>
                            </div>                    
                        </div> -->
                    </div>
                    <div class="shipment_destination">
                        <div class="shipment_header">
                            <i class="fa-solid fa-location-dot"></i> {$_('shipment.destination')}
                        </div> 
                        <div class="input_box">
                            {#if shipment.destination.datalogics_platform_id==54}
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.package_type')}</label>      
                                <select bind:value={shipment.destination.datalogics_package_type}>
                                    <option value="1">{$_('shipment.package_type_types.regular')}</option>
                                    <option value="2">{$_('shipment.package_type_types.big')}</option>
                                    <option value="5">{$_('shipment.package_type_types.half')}</option>
                                    <option value="3">{$_('shipment.package_type_types.envalope')}</option>
                                    <option value="4">{$_('shipment.package_type_types.special')}</option>                                    
                                </select>
                            </div>
                            {/if}
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.shipping_type')}</label>      
                                <select bind:value={shipment.destination.datalogics_shipment_type}>
                                    <option value="1"> {$_('shipment.delivery')}</option>
                                    <option value="2"> {$_('shipment.double_govina')}</option>
                                    <option value="3"> {$_('shipment.pickup')}</option>
                                </select>
                            </div>
                            {#if shipment.destination.datalogics_shipment_type=="2"}
                            <div class="input_con">
                                <label>{$_('shipment.govina_sum')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_govina_sum}>
                            </div>
                            {/if}
                            <div class="input_con">
                                <label>{$_('shipment.packages')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_packs}>
                            </div> 
                            <div class="input_con">
                                <label>{$_('shipment.weight')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_weight}>
                            </div>                            
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_fullname} class:input_empty_error={shipment.destination.datalogics_fullname === ''}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_phone} class:input_empty_error={shipment.destination.datalogics_phone === ''}>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_email}>
                            </div>                        
                        </div>


                        
                        {#if Object.keys(stores).length && platforms[shipment.destination.datalogics_platform_id] && platforms[shipment.destination.datalogics_platform_id].pickup && platforms[shipment.destination.datalogics_platform_id].pickup=="1"}
                        <div class="input_box">
                            <div class="input_con radio">
                                <input id="shipment_type1" type="radio" name="shipment_type" bind:group={shipment.destination.datalogics_shipment_select} value="1">
                                <label for="shipment_type1"><i class="fa-solid fa-asterisk"></i> {$_('shipment.specific_location')}</label>
                            </div>
                            <div class="input_con radio">
                                <input id="shipment_type2" type="radio" name="shipment_type" bind:group={shipment.destination.datalogics_shipment_select}  value="2">
                                <label for="shipment_type2"><i class="fa-solid fa-asterisk"></i> {$_('shipment.pudo')}</label>
                            </div>
                        </div>
                        {/if}
                        {#if shipment.destination.datalogics_shipment_select==1}
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_city} class:input_empty_error={shipment.destination.datalogics_city === ''}>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_address} class:input_empty_error={shipment.destination.datalogics_address === ''}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.house')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_house}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_apartment}>
                            </div>
                        </div>
                        {:else}
                            <div class="input_box flex flex-col items-start gap-1 mt-5">
                                <div class="font-bold">{$_('shipment.customer_address')}</div>
                                <div>{$_('shipment.customer_address_note')}</div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                    <input type="text" bind:value={shipment.destination.datalogics_city} class:input_empty_error={shipment.destination.datalogics_city === ''}>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                    <input type="text" bind:value={shipment.destination.datalogics_address} class:input_empty_error={shipment.destination.datalogics_address === ''}>
                                </div>
                            </div>
                            {#if shipment.destination.datalogics_city!=''}
                            <div class="input_box">
                                <div class="input_con radio checkbox text-center mt-[0px]">                                
                                    <input type="checkbox" id="auto" bind:checked={shipment.destination.datalogics_n_code_auto}>
                                    <label for="auto"><span></span></label>
                                    <span class="p-1 px-3">
                                        {$_('shipment.auto_select_ncode_based_on_shipping_location')} 
                                        <strong>
                                        {#if shipment.destination.datalogics_address!=''}
                                            {shipment.destination.datalogics_address} {shipment.destination.datalogics_house} ,
                                        {/if}
                                        {shipment.destination.datalogics_city}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                            {/if}
                            {#if shipment.destination.datalogics_n_code_auto==false}
                            <div class="input_box flex flex-col items-start gap-1 mt-5 font-bold">
                                {$_('shipment.pudo_location_title')}
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                    <select bind:value={shipment.destination.datalogics_n_code_city}>
                                        <option value="">יש לבחור עיר</option>
                                        {#each Object.keys(stores) as item,index}
                                            <option value="{item}">{item}</option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.podu_location')}</label>
                                    <select bind:value={shipment.destination.datalogics_n_code}>
                                        <option value="">יש לבחור ממס</option>
                                        {#if shipment.destination.datalogics_n_code_city!='' && stores[shipment.destination.datalogics_n_code_city].length}
                                            {#each stores[shipment.destination.datalogics_n_code_city] as item,index}
                                                <option value="{item.n_code.toString()}">{item.name} - {item.street} {item.house}</option>
                                            {/each}
                                        {/if}
                                    </select>
                                </div>
                                
                            </div>
                            {/if}                            
                            <!-- <div class="input_box">
                                <div class="input_con">
                                    <label>{$_('shipment.destination_comments')}</label>
                                    <input type="text" bind:value={shipment.destination.datalogics_comments}>
                                </div>                    
                            </div> -->
                        {/if}
                    </div>            
                </div>   
                <div class="shipment-flex">
                    <div class="input_box">
                        <div class="input_con">
                            <label>{$_('shipment.general_comments')}</label>
                            <input type="text" bind:value={shipment.destination.datalogics_comments}>
                        </div>
                        <div class="input_con">
                            <label>{$_('shipment.reference')}</label>
                            <input type="text" bind:value={shipment.destination.datalogics_reference}>
                        </div>
                    </div>
                </div>    
                <!-- <div class="shipment-flex-button">
                    <div class="create_button" on:click={()=>{ create_new = false; handleSubmit(); }}>{$_('shipment.create_shipment')}</div>
                    {#if $UserStore.id==1601}
                    <div class="create_button red-notice" on:click={()=>{ create_new = true; handleSubmit(); }}>{$_('shipment.create_new_shipment')}</div>
                    {/if}
                </div>  -->
                <div class="orders-bulk-con items-center">
                    {#if shipment.shipment_id >0 && platforms[shipping_push_supplier] && platforms[shipping_push_supplier].cancel && platforms[shipping_push_supplier].cancel=="1"}                    
                    <div class="button" on:click={()=> CancelShipment() }>{$_('shipment.cancel')}</div>
                    {/if}
                    {#if shipment.shipment_id=='' || shipment.shipment_id==null || shipping_push_supplier==62}
                    <div class="button" class:border-0={printers.length} on:click={()=>{ create_new = false; handleSubmit(); }}>{#if shipment.shipment_id=='' || shipment.shipment_id==null}{$_('shipment.create_shipment')}{:else}{$_('shipment.update_shipment')}{/if}</div>
                    {:else}
                    <div class="button red-notice" class:border-0={printers.length} on:click={()=>{ create_new = true; handleSubmit(); }}>{$_('shipment.create_new_shipment')}</div>
                    {/if}
                    {#if shipment.shipment_id!='' && shipment.shipment_id!=null}
                        <div class="button" on:click={()=> BulkPrint() }>
                            {$_('shipment.print')}
                        </div>
                        {#if printers.length}
                        <div class="button">                        
                            <select bind:value={settings.printer} class="text-black p-1">
                                {#each printers as printer}
                                    <option value={printer}>{printer}</option>
                                {/each}
                            </select>                        
                        </div>
                        {/if}
                    {/if}
                    {#if $UserStore?.erp == 1}
                        {#if shipment.external_id == null}
                        <div class="button" on:click={()=>{ createOrder(); }}>{$_('shipment.create_invoice')}</div>
                        {/if}
                        <div class="button" on:click={()=>{ printSlip(); }}>{$_('shipment.create_slip')}</div>
                        {#if shipment.status_code<3}                
                        <div class="button" on:click={()=>{ changeStatus(); }}>{$_('shipment.close_order')}</div>
                        {/if}
                    {/if}
                </div>
            {/if}
        </div>
        
    </div>
</div>

<style>   

    
    .shipment-flex {
        text-align: center;
        display: flex;  
    }
    
    .shipment-flex > div {
        flex:1;
        padding:10px;
    }
    
    .shipment_header {
        color: var(--theme-one-color);
        padding: 10px 0;
        margin-bottom: 20px;
        /* border-radius: 10px; */
        font-size: 22px;
        text-align: start;
        border-bottom: 1px solid rgb(171 171 171);
    }
    
    
    .shipment_header i {
        color: rgb(73 73 73)
    }

    .shipment_notification {
        padding:10px;
        border:1px solid green;
        background-color: rgb(228, 255, 228);
        border-radius:10px;
        margin-bottom: 10px;
    }
    .shipment-items-box {
        display: table;
        width:100%;
        font-size: 14px;;
    }
    .shipment-items-line-head {
        font-weight: bold;
    }
    .shipment-items-line {
        display:table-row;
        width: 100%;        
    }
    .shipment-items-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(171 171 171);  
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: center;
    }
    .shipment-status-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: right;
    }
    .shipment-status-line > div:first-child {
        width:200px;
    }
    .qty {
        background-color: #5b5b5b;
        color: white;
        border-radius: 5px;;
        padding:5px;
        display: inline-block;
        width: 20px;;
        text-align: center;
    }
    .qty-scanned {
        background-color: #262626;
    }
    .badge {
        width: 90px;
        background-color: #60a325;
        color: white;
        border-radius: 5px;;
        padding:5px 10px;
        display: inline-block;
    }
    .badge0 {
        background-color: var(--theme-one-color);
    }
    .badge1 {
        background-color: #234fe0;
    }

    @media screen and (max-width:600px) {
        .shipment-flex {
            text-align: center;
            display: flex;  
            flex-direction: column;
        }
    }

</style>